import Button from '../../Button';
import DropdownMenu from '../../DropdownMenu';

const months = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
];

interface DatePickerMonthsProps {
  selectedMonth: number;
  setSelectedMonth: (month: number) => void;
}

const DatePickerMonths = ({
  selectedMonth,
  setSelectedMonth,
}: DatePickerMonthsProps) => {
  return (
    <DropdownMenu>
      <DropdownMenu.Trigger asChild>
        <Button size='condensed' variant='outlined' color='secondary'>
          {months[selectedMonth]}
        </Button>
      </DropdownMenu.Trigger>
      <DropdownMenu.Content align='start' portal={false}>
        {months.map((month, index) => (
          <DropdownMenu.Item
            key={month}
            onClick={() => setSelectedMonth(index)}
          >
            {month}
          </DropdownMenu.Item>
        ))}
      </DropdownMenu.Content>
    </DropdownMenu>
  );
};

export default DatePickerMonths;
